import React, { useEffect, useState } from "react";
import {
  geAddClassListForAge,
  getAddClassList,
} from "../../../adminApi/addClassList";
import { toast } from "react-toastify";
import LoaderComponent from "../../../components/LoaderComponent.jsx";
import { useSelector } from "react-redux";
import axios from "axios";
import { ReactComponent as CloseIcon } from "../../../assets/images/icons/close-icon.svg";
import getPrograms from "../../../adminApi/categories.js";
import Select from "react-select";
import { customStyles } from "../../../adminUtility.js";

const AddClassModal = ({
  setShowAddClassModal,
  classProgramId,
  classProgramName,
  activeAccordion,
  isEnrichmentCombo,
  getManageDataFunction,
  manageData,
  enrichmentManageClass,
  enrichmentCategoryId,
  setManageEnrichmentData,
}) => {
  const page = useSelector((state) => state?.adminSlice?.adminModalContent);
  const [selectedImage, setSelectedImage] = useState();
  const token = localStorage.getItem("access_token");
  const [classList, setClassList] = useState([]);
  const [description, setDescription] = useState();
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({});
  const [convertedImage, setConvertedImage] = useState();
  const [classId, setClassId] = useState();
  const [loading, setLoading] = useState();
  const [category, setCategory] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [umbrellaClassName, setUmbrellaClassname] = useState("");
  const [sortKey, setSortKey] = useState({
    sortId: "1",
    isAsc: true,
  });
  const selectClassHandler = (selectedOption) => {
    setClassId(selectedOption.value);
  };

  const handleProgramEventImage = async (e) => {
    setSelectedImage(e.target.value);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        // Create an image element to get the natural width and height
        const image = new Image();
        image.src = reader.result;

        image.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set canvas dimensions to desired width and height
          const desiredWidth = 635;
          const desiredHeight = 412;
          canvas.width = desiredWidth;
          canvas.height = desiredHeight;

          // Draw image on canvas with desired dimensions
          ctx.drawImage(image, 0, 0, desiredWidth, desiredHeight);

          // Get the data URL of the resized image
          const resizedImageDataUrl = canvas.toDataURL("image/png");

          const convertedFile = {
            image: resizedImageDataUrl,
          };
          const convertedFileName = {
            name: file.name,
          };

          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });

          const postProgramImageData = {
            image: convertedFile.image,
          };

          setConvertedImage(postProgramImageData?.image);
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAddClassListFunc();
  }, []);

  const getAddClassListFunc = async () => {
    let response;
    if (activeAccordion == "1") {
      setShowLoader(true);
      response = await geAddClassListForAge(token);
      setClassList(response);
      setShowLoader(false);
    } else {
      setShowLoader(true);
      response = await getAddClassList(token);
      setClassList(response);
      setShowLoader(false);
    }
    setShowLoader(true);
    const categoryRes = await getPrograms(
      token,
      formData,
      page,
      sortKey,
      "1000000"
    );

    setCategory(categoryRes?.data);
    setShowLoader(false);
  };

  const addClassHandler = async () => {
    try {
      if (manageData && activeAccordion === 0 && enrichmentManageClass) {
        try {
          setLoading(true);
          const postData = {
            image: convertedImage,
            description: description,
            fk_category_class_cms: parseInt(enrichmentCategoryId),
            programId: parseInt(classProgramId),
            classId: parseInt(classId),
            umbrella_name: umbrellaClassName ? umbrellaClassName : " ",
          };
          const response = await axios.post(
            process.env.REACT_APP_BASE_URL + `/admin/add_class_to_category`,
            postData,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response?.status === 200 || response?.status === 201) {
            const postData = {
              categoryId: enrichmentCategoryId,
            };
            const tempResponse = await axios.post(
              process.env.REACT_APP_BASE_URL +
                `/admin/getClassesCMSAdminForCombo2`,
              postData,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const enrichmentManageData = tempResponse?.data?.data?.map(
              (enrichmentInnerManegeData, index) => {
                return {
                  data: [
                    enrichmentInnerManegeData?.id
                      ? enrichmentInnerManegeData?.id
                      : "-",
                    enrichmentInnerManegeData?.name
                      ? enrichmentInnerManegeData?.name
                      : "-",
                    "Gymtime",
                  ],
                };
              }
            );
            setManageEnrichmentData(enrichmentManageData);
            setLoading(false);
            setShowAddClassModal(false);
            toast.success("Class added Successfully");
            return;
          }
        } catch (error) {
          console.error("error");
          toast.error(error);
        }
      }
      if (isEnrichmentCombo !== "Enrichment Combos") {
        if (activeAccordion == "0") {
          // if (umbrellaClassName == "") {
          //   toast.error("Enter Umbrella Class Name to Proceed !");
          //   return;
          // }
          const postData = {
            image: convertedImage,
            description: description,
            classId: classId,
            programId: classProgramId,
            fk_sub_program_cms: 2,
            type: 0,
            umbrella_name: umbrellaClassName,
          };
          setLoading(true);
          const responseProgram = await axios.post(
            process.env.REACT_APP_BASE_URL +
              `/admin/update_classes_cms_foradmin_withNoFk`,
            postData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (
            responseProgram?.status === 200 ||
            responseProgram?.status === 201
          ) {
            setLoading(false);
            setShowAddClassModal(false);
            toast.success("Class added Successfully");
          }
        } else {
          const postData = {
            image: convertedImage,
            description: description,
            classId: classId,
            age_range_id: classProgramId,
          };
          setLoading(true);
          const responseAge = await axios.post(
            process.env.REACT_APP_BASE_URL +
              `/admin/update_classes_cms_foradmin_withNoFk`,
            postData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (responseAge?.status === 200 || responseAge?.status === 201) {
            setShowAddClassModal(false);
            setLoading(false);
            toast.success("Class added Successfully");
          }
        }
      } else {
        const postData = {
          image: convertedImage,
          description: description,
          categoryId: classId,
          programId: classProgramId,
        };
        setLoading(true);
        const postEnrichmentData = await axios.post(
          process.env.REACT_APP_BASE_URL +
            `/admin/update_category_cms_foradmin_withNoFk`,
          postData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (
          postEnrichmentData?.status === 200 ||
          postEnrichmentData?.status === 201
        ) {
          setShowAddClassModal(false);
          setLoading(false);
          toast.success("Category added Successfully");
        }
      }
      getManageDataFunction();
    } catch (error) {
      toast.error(error);
      console.error(error);
      setLoading(false);
      setShowAddClassModal(false);
    }
  };

  const dropDownList =
    isEnrichmentCombo === "Enrichment Combos" && enrichmentManageClass == false
      ? category
      : classList;

  const classOptions = [
    {
      value: "",
      label:
        isEnrichmentCombo === "Enrichment Combos" &&
        enrichmentManageClass == false
          ? "Select Category"
          : "Select Class",
    },
    ...(Array.isArray(dropDownList)
      ? dropDownList
          .filter((val) => val?.name.trim() !== "")
          .map((val) => ({
            show: val?.name,
            value: parseInt(val.id),
            label: `${val?.name}`,
          }))
      : []),
  ];

  return (
    <>
      {loading && <LoaderComponent />}
      <div
        className="Admin-modal Admin-modal--open"
        id="modalCategory"
        role="dialog"
      >
        <div className="Admin-modal__dialog Admin-modal__dialog--sm">
          <div className="Admin-modal__content" style={{ width: "200%" }}>
            <div className="Admin-modal__head">
              <h2 className="Admin-modal__head--title">
                {manageData && activeAccordion === 0 && enrichmentManageClass
                  ? "+Add New Class"
                  : isEnrichmentCombo !== "Enrichment Combos"
                  ? "+Add New Class"
                  : "+Add Category"}
              </h2>

              <button
                className="Admin-modal__close"
                onClick={() => setShowAddClassModal(false)}
              >
                <CloseIcon />
              </button>
            </div>

            <div className="Admin-modal__body">
              <div className="input_formGroup">
                {isEnrichmentCombo !== "Enrichment Combos" && (
                  <div className="form__group">
                    <label htmlFor="">Umbrella Class Name</label>
                    <input
                      type="text"
                      className="adminform__input"
                      placeholder="Umbrealla Class Name"
                      name="umbrella_name"
                      value={umbrellaClassName}
                      onChange={(e) => {
                        setUmbrellaClassname(e.target.value);
                      }}
                    />
                  </div>
                )}

                {isEnrichmentCombo === "Enrichment Combos" &&
                  enrichmentManageClass && (
                    <div className="form__group">
                      <label htmlFor="">Umbrella Class Name</label>
                      <input
                        type="text"
                        className="adminform__input"
                        placeholder="Umbrealla Class Name"
                        name="umbrella_name"
                        value={umbrellaClassName}
                        onChange={(e) => {
                          setUmbrellaClassname(e.target.value);
                        }}
                      />
                    </div>
                  )}

                <div className="form__group">
                  <label htmlFor=""> Program</label>

                  <input
                    type="text"
                    className="adminform__input"
                    placeholder="Program Name"
                    value={classProgramName}
                  />
                </div>
                <div className="form__group">
                  <label htmlFor="">Select Class</label>

                  <Select
                    name="ClassList"
                    styles={customStyles}
                    options={classOptions}
                    placeholder={
                      isEnrichmentCombo === "Enrichment Combos" &&
                      enrichmentManageClass == false
                        ? "Select Category"
                        : "Select Class"
                    }
                    onChange={(selectedOption) =>
                      selectClassHandler(selectedOption)
                    }
                  />
                </div>
              </div>
              <div
                class="accordion__card__body"
                style={{ display: "block", margin: "0 ", padding: "20px 0 " }}
              >
                <div class="commonList">
                  <div class="commonList__row">
                    <div class="commonList__row__col">
                      <label htmlFor=" " style={{ minWidth: "120px" }}>
                        Class Image
                      </label>
                      <div class="cardbox">
                        <div class="browseBox">
                          <div class="browseFile">
                            <div class="browseFile__icon">
                              <svg
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                              >
                                <rect
                                  x="0.180664"
                                  width="32.53"
                                  height="32.53"
                                  fill="url(#pattern0)"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                  >
                                    <image xlinkHref="data:image/png;base64,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" />
                                  </pattern>
                                </defs>
                              </svg>
                            </div>
                            <h4 class="browseFile__text">
                              Drag files to upload
                            </h4>
                            <p class="browseFile__ortext">or</p>
                            <input
                              class="hiddenInput"
                              id="BrowseFiles"
                              type="file"
                              onChange={(e) => handleProgramEventImage(e)}
                            />
                            <label for="BrowseFiles" class="browseBtn">
                              Browse Files
                            </label>
                            <h6 className="programSelectedFile">
                              {selectedImage?.split("\\").pop()}
                            </h6>
                            <div class="browseFileData">
                              <p class="browseFileData__text">
                                Max File Size: <strong>10 MB</strong>
                              </p>
                              <p class="browseFileData__text">
                                Supported file type:{" "}
                                <strong>JPG,PNG,SVG</strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="commonList__row" style={{ gap: "0px" }}>
                    <label htmlFor="" style={{ marginBottom: "0px" }}>
                      Description
                    </label>
                    <div class="form__group">
                      <div class="adminform__group">
                        <textarea
                          class="adminform__textarea"
                          placeholder="write the contents here!"
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                      <div class="adminbutton__group">
                        <button
                          class="admibtn admibtn-primary"
                          onClick={addClassHandler}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddClassModal;
